import React from 'react';
export const LineOptionsUsers = {
    chartArea: { left: '10%', top: '10%', width: '85%', height: '80%' },
    colors: ['orange'],
    legend: 'none',
};

export const LineOptionsRevenue = {
    chartArea: { left: '10%', top: '10%', width: '85%', height: '80%' },
    colors: ['green'],
    legend: 'none',
};

export const columnsFranchisesTable = [
    {
        Header: <b>Usuario</b>,
        accessor: 'name',
        Cell: null,
        style: {
            textAlign: 'left',
        },
    },
    {
        Header: <b>Ver</b>,
        accessor: 'show',
        Cell: (row) => (
            <div>
                <span onClick={() => (window.location.href = `/dashboard/${row.original.id}`)}>
                    <i
                        className="fa fa-eye"
                        style={{
                            width: 35,
                            fontSize: 20,
                            padding: 11,
                            color: '#000000',
                            cursor: 'pointer',
                        }}
                    ></i>
                </span>
            </div>
        ),
        style: {
            textAlign: 'center',
        },
        width: 150,
    },
];

export const columnsUsersTable = [
    {
        Header: <b>Nombre</b>,
        accessor: 'name',
        Cell: (row) => (
            <div>
                <a
                    href={`/dashboard/${row.original.franchise.id}/users/${row.original.id}`}
                >
                    {row.original.name}
                </a>
            </div>
        ),
        style: {
            textAlign: 'left',
        },
    },
];

export const columnsDeliveryUsersTable = [
    {
        Header: <b>Nombre</b>,
        accessor: 'userName',
        Cell: (row) => (
            <div>
                <a href={`/dashboard/${row.original.franchiseId}/users/${row.original.userId}`}>
                    {row.original.userName}
                </a>
            </div>
        ),
        style: {
            textAlign: 'left',
        },
    },
    {
        Header: <b>Conteo diario</b>,
        accessor: 'count',
        Cell: null,
        style: {
            textAlign: 'center',
        },
        width: 150,
    },
    {
        Header: <b>Cambios</b>,
        accessor: 'changes',
        Cell: null,
        style: {
            textAlign: 'center',
        },
        width: 150,
    },
];

export const getSalesSummary = (orders) => {
    const validOrders = orders.filter(order => {

        // return accounts to the payment method
        // const hasAccounts =
        //     Array.isArray(order.paymentMethod?.accounts) &&
        //     order.paymentMethod.accounts.length > 0;
        return order.paymentMethod.name !== "Bancolombia (COP)" && order.paymentMethod.name !== "Pago móvil (VES)" && order.subscription == null;
    });

    const products = {};
    const amounts = {};
    let observations = 0;
    let coupons = 0;

    validOrders.forEach(order => {
        // Observaciones
        if (order.observation?.trim()) {
            observations++;
        }

        if (order.couponId) {
            console.log(order.couponAmount)
            coupons++;
        }

        // Productos y montos
        (order.products || []).forEach(product => {
            let quantity = Number(product.purchaseProducts?.quantity || 0);
            const unitPrice = Number(product.purchaseProducts?.unitPrice || 0);
            const name = product.name;
            let couponAmount = 0;

            if (order.couponId) {
                // se resta el monto completo de la recarga
                // deberia restarse el monto del cupón m
                //quantity--;
                couponAmount = Number(order.couponAmount)
            }

            // Productos
            products[name] = (products[name] || 0) + quantity;

            // Montos por moneda
            const currency = order.paymentMethod?.currency || "N/A";

            amounts[currency] =
                (amounts[currency] || 0) + (quantity * unitPrice - couponAmount);
        });
    });

    return {
        products: Object.entries(products)
            .map(([name, quantity]) => ({
                name,
                quantity
            }))
            .sort((a, b) => b.quantity - a.quantity),

        amounts,
        observations,
        coupons
    };
}

export const formatProducts = (products) => {
    return products
        .map(({ name, quantity }) => {
            const plural = quantity > 1 ? "s" : "";
            return `${quantity} ${name.toLowerCase()}${plural}`;
        })
        .join(", ");
}

export const formatAmounts = (amounts) => {
    const labels = {
        COP: "pesos",
        USD: "dólares",
        VES: "bolívares"
    };

    return Object.entries(amounts)
        .map(([currency, amount]) => {
            const formatter =
                currency === "COP"
                    ? new Intl.NumberFormat("es-CO")
                    : new Intl.NumberFormat("en-US");

            return `${formatter.format(amount)} ${labels[currency] || currency}`;
        })
        .join(" y ");
}

export const formatObservations = (count) => {
    return `${count} observación${count !== 1 ? "es" : ""}`;
}
export const formatCoupons = (count) => {
    return `${count} ${count !== 1 ? "cupones" : "cupón"}`;
}